<div class="ss-table" [ssLoading]="loading">
  <div class="ss-table-scroll">
    <p-table [value]="rows" [tableStyle]="{ 'min-width': '100%' }" [ssTableExport]="paging ? null : options.exportName">
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="expandable" scope="col" class="ss-table__expander-col"><span class="sr-only">Expandir</span></th>
          <th
            *ngFor="let column of columns; let index = index"
            scope="col"
            [class]="columnClass(column)"
            [class.sortable]="isOrderable(column)"
            [class.is-asc]="sortDirection(index) === 'asc'"
            [class.is-desc]="sortDirection(index) === 'desc'"
            [style.width]="width(column)"
            [attr.aria-sort]="sortDirection(index) === 'asc' ? 'ascending' : sortDirection(index) === 'desc' ? 'descending' : null"
            [attr.tabindex]="isOrderable(column) ? 0 : null"
            (click)="sortBy(index)"
            (keydown.enter)="sortBy(index)"
            (keydown.space)="$event.preventDefault(); sortBy(index)">
            <ng-container *ngIf="column.headerHtml; else defaultHeader">
              <span [innerHTML]="column.headerHtml | ssTrustedHtml"></span>
            </ng-container>
            <ng-template #defaultHeader>{{ column.title }}</ng-template>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr [attr.tabindex]="rowClick.observed ? 0 : null" [class.ss-table-row-clickable]="rowClick.observed" [class.is-expanded]="expandable && isExpanded(row)" (click)="onRowClick($event, row)" (keydown.enter)="onRowClick($event, row)">
          <td *ngIf="expandable" class="ss-table__expander-col">
            <button
              type="button"
              class="ss-table__expander"
              [class.is-open]="isExpanded(row)"
              [attr.aria-expanded]="isExpanded(row)"
              [attr.aria-controls]="detailId(row, rowIndex)"
              [attr.aria-label]="expandLabel(row)"
              (click)="$event.stopPropagation(); toggleRow(row)"
              (keydown.enter)="$event.stopPropagation()">
              <lucide-icon name="chevron-right" [size]="16" aria-hidden="true"></lucide-icon>
            </button>
          </td>
          <td
            *ngFor="let column of columns; let columnIndex = index"
            [class]="columnClass(column)"
            [innerHTML]="cell(row, rowIndex, column, columnIndex) | ssTrustedHtml">
          </td>
        </tr>
        <tr *ngIf="expandable && isExpanded(row)" class="ss-table__detail-row">
          <td [attr.colspan]="columns.length + 1" [attr.id]="detailId(row, rowIndex)">
            <div class="ss-table__detail">
              <div class="ss-table__detail-inner" [innerHTML]="options.rowDetail!(row) | ssTrustedHtml"></div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="ss-table--empty" [attr.colspan]="columns.length + (expandable ? 1 : 0)">{{ loading ? 'Carregando…' : 'Nenhum resultado encontrado' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ss-pagination
    *ngIf="paging"
    [total]="total"
    [page]="page"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [label]="options.label || 'resultados'"
    (pageChange)="changePage($event)">
  </ss-pagination>
</div>
